import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import CollapsibleCard from 'core/components/collapsible-card';
import { Label } from 'core/components/label';
import useStyles from './sweep-account.styles';

// Same section shell as the staff quote form (quote/components/collapsible): a white
// collapsible card header with an infoSubtitle title over a beige_25 field grid.
const CollapsibleSection = ({ title, children, ...props }) => {
  const classes = useStyles();
  return (
    <CollapsibleCard initialOpen content={<Label type="infoSubtitle">{title}</Label>} {...props}>
      <Grid spacing={4} container justifyContent="space-between" className={classes.cardBody}>
        {children}
      </Grid>
    </CollapsibleCard>
  );
};

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default CollapsibleSection;
